import { Flex } from "@chakra-ui/layout";
import type { ConsultantAccount } from "@models/ConsultantAccount";
import { getConsultantCompetences } from "@utils/utils";
import { useOrganisation } from "@api/hooks";

interface Props {
	competences: ConsultantAccount["profile"]["competences"];
}

export const ConsultantCompetencePills: React.FC<Props> = ({ competences, ...rest }) => {
	const { organisation, isLoading } = useOrganisation();

	if (isLoading) {
		return null;
	}

	return (
		<Flex align={["center", "center", "flex-start", "flex-start"]}>
			<Flex
				w="100%"
				direction={"row"}
				flexWrap={"wrap"}
				gap={"0.4rem"}
				justifyContent={["center", "center", "flex-start"]}
			>
				{getConsultantCompetences(competences, organisation?.competences).map((str) => {
					return (
						<Flex
							fontStyle={"normal"}
							fontWeight={500}
							fontSize={"14px"}
							lineHeight={"17px"}
							align={"center"}
							textAlign={"center"}
							display={"inline-block"}
							color={"black"}
							padding={["5px 9px", null, null, "6px 12px"]}
							key={str}
							background={"rgba(78, 126, 167, 0.2)"}
							border={"1px solid #4e7ea7"}
							borderRadius={"40px"}
							{...rest}
						>
							{str}
						</Flex>
					);
				})}
			</Flex>
		</Flex>
	);
};
